import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { DataProvider } from './contexts/DataContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import ProtectedRoute from './ProtectedRoute';
import SubscriptionGuard from './components/SubscriptionGuard';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import OAuthCallback from './pages/OAuthCallback';
import SuspendedAccount from './pages/SuspendedAccount';
import DashboardLayout from './layout/DashboardLayout';
import Overview from './pages/dashboard/Overview';
import ReviewsDashboard from './pages/dashboard/ReviewsDashboard';
import SeoReports from './pages/dashboard/SeoReports';
import SocialMedia from './pages/dashboard/SocialMedia';
import Posters from './pages/dashboard/Posters';
import Directory from './pages/dashboard/Directory';
import Accounts from './pages/dashboard/Accounts';
import Users from './pages/dashboard/Users';
import AccountMigration from './pages/dashboard/AccountMigration';
import AccountSettings from './pages/dashboard/AccountSettings';


function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <DataProvider>
            <SubscriptionProvider>
              <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/oauth-callback" element={<OAuthCallback />} />
              <Route path="/suspended" element={<SuspendedAccount />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <SubscriptionGuard>
                      <DashboardLayout />
                    </SubscriptionGuard>
                  </ProtectedRoute>
                }
              >
                <Route index element={<Overview />} />
                <Route path="feedback" element={<ReviewsDashboard />} />
                <Route path="seo" element={<SeoReports />} />
                <Route path="social" element={<SocialMedia />} />
                <Route path="posters" element={<Posters />} />
                <Route path="directory" element={<Directory />} />
                <Route path="accounts" element={<Accounts />} />
                <Route path="users" element={<Users />} />
                <Route path="migration" element={<AccountMigration />} />
                <Route path="settings" element={<AccountSettings />} />
              </Route>
            </Routes>
            </SubscriptionProvider>
          </DataProvider>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
